












































import BaseComponent from '@/core/base.component';
import { Component, Vue, Watch } from 'vue-property-decorator';
import { CompanyUserDto } from '../../../dto/company-user';
import companyUserService from '../../../services/company-user.service';
import { Pagination } from '@/common/interfaces/pagination.type';
import UserAddDialog from '@/modules/company/components/UserAddDialog.vue';
import CommonTable from '@/modules/_common/components/CommonTable.vue';
@Component({
  components: { UserAddDialog },
})
export default class User extends BaseComponent {
  private companyUserList: CompanyUserDto[] = [];
  private pagination = new Pagination();
  private dataLoading = false;
  private companyUserListCount = null;
  private userAddDialog = false;
  private headers = [
    {
      text: '이름',
      value: 'name',
      align: 'center',
    },
    {
      text: '핸드폰 번호',
      value: 'phone',
      align: 'center',
    },
    {
      text: '이메일',
      value: 'email',
      align: 'center',
    },
    {
      text: '상태',
      value: 'codeManagement.value',
      align: 'center',
    },
  ];
  //페이지네이션 페이지 length
  // get pageCount(): number {
  //   return Math.ceil(this.companyUserListCount / this.pagination.limit);
  // }
  // //pagination 객체가 변할때마다 리스트를 새로가져옴
  // @Watch('pagination', {
  //   deep: true,
  // })
  // paginationChanged() {
  //   this.getList();
  // }

  getList() {
    this.dataLoading = true;
    companyUserService.findAll(null, this.pagination).subscribe(res => {
      this.dataLoading = false;
      this.companyUserList = res.data.items;
      this.companyUserListCount = res.data.totalCount;
    });
  }
  toSelectedItemPage(value) {
    this.$router.push(`/company/user/${value.no}`);
  }
  created() {
    this.getList();
  }
  activated() {
    this.getList();
  }
}
